var UA = require('../internals/engine-user-agent');

module.exports = /MSIE|Trident/.test(UA);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-ie-or-edge.js
// module id = 261
// module chunks = 0